import { Checkbox, ConfigProvider } from 'antd';

const MyCheckbox = (props) => {
  const { data, checkedList=[], onChange=()=>{}, className, value } = props;
  console.log(value, "=valueeeee:MyCheckBox");
  const CheckboxGroup = Checkbox.Group;
  return (
    // <Checkbox onChange={onChange}>{title}</Checkbox>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: 'rgb(234, 88, 12)',
          colorText: '#8F8F8F',
        },
      }}
    >
        <CheckboxGroup 
          className={`${className} flex items-center `} 
          options={data} 
          value={value} 
          onChange={onChange}
          style={{ display: 'flex', color: '#8F8F8F' }}
        />
    </ConfigProvider>
  );
}

export default MyCheckbox;